module.exports = __webpack_public_path__ + "static/gm-29-fe751ad6b8c17e090f328b92a8f9a36a.jpg";